import { Shirt, UserIcon } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const inventorySubNav: RouteListItem[] = [
  {
    path: '/inventory/$id',
    icon: Shirt,
    name: 'Profile',
    auditKey: 'inventory/profile',
  },
  {
    path: '/inventory/$id/vendors',
    icon: UserIcon,
    name: 'Vendors',
    auditKey: 'inventory/vendors',
  },
];
